import { gorgiasTicketSummarySchema } from "@redotech/redo-integrations-definitions-common/gorgias/gorgias-types";
import * as z from "zod";

export const getDisputeGorgiasTickets = {
  name: "getDisputeGorgiasTickets" as const,
  input: z.object({ disputeId: z.coerce.bigint() }),
  output: z.object({ tickets: z.array(gorgiasTicketSummarySchema) }),
};
